import { Grid, useTheme, Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';

import NavBar from '../components/NavBar';
import { useLocation, useNavigate, useParams } from 'react-router';
import '../../index.css';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { getCurrentDateTime } from '../../services/home_services';
import useAnalyticsEventTracker from '../../services/analytics_services';
import { primaryColor, styles } from '../../assets/styles/styles';
import { Helmet } from 'react-helmet';
import { PageType, setCurrentPage } from '../../store/slices/general.slice';
import { useDispatch } from 'react-redux';
import { getMobileOperatingSystem } from '../../services/general_services';
import Features from '../components/Features';
import { db } from '../../services/firebase_services';
import OurClients from '../components/OurClients';
import { FadeInComponent } from '../components/FadeInComponent';

export default function Home() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const appTrigger = params.get('appTrigger');
  const link = params.get('link');
  const id = params.get('id');

  const sponsor = params.get('sponsorInfo');

  const localStyles = {
    centerVert: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      height: '200px',
    },
  };
  const navigate = useNavigate();
  const theme = useTheme();
  const { install } = useParams();
  const deepLink = 'routebuddies://';

  useEffect(() => {
    let fallbackTimeout: any;

    const redirectToDeepLink = () => {
      let location = deepLink;

      if (id && link) {
        location += `${link}/${id}`;
      } else if (link) {
        location += link;
      }

      console.log('Trying deep link:', location);

      // Create an iframe to attempt opening the deep link
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = location;
      document.body.appendChild(iframe);

      // Remove the iframe after attempting
      setTimeout(() => document.body.removeChild(iframe), 1000);
    };

    async function redirectToSponsor() {
      let dateTime = getCurrentDateTime();
      await db.ref('/new_data/sponsor_visits/impactive_it/').push({
        dateTime,
      });
      let location = 'https://impactiveit.com';

      window.location.href = location;
    }

    const redirectToFallback = () => {
      const platform = getMobileOperatingSystem();
      const fallbackLink =
        platform === 'Android'
          ? 'https://play.google.com/store/apps/details?id=com.routebuddies'
          : 'https://apps.apple.com/gb/app/routebuddies/id6443986928';

      console.log('Fallback?');
      window.location.href = fallbackLink;
    };

    const tryRedirect = () => {
      try {
        redirectToDeepLink();

        fallbackTimeout = setTimeout(() => {
          redirectToFallback();
        }, 200); // Adjust timeout as needed
      } catch (err) {
        console.log(err);
      }
    };

    const handleBlur = () => {
      // If the window loses focus before the timeout fires, clear the timeout
      clearTimeout(fallbackTimeout);
    };

    if (appTrigger) {
      gaEventTracker('appTrigger');

      tryRedirect();

      window.addEventListener('blur', handleBlur);

      // Cleanup function to remove the event listener
      return () => {
        window.removeEventListener('blur', handleBlur);
      };
    } else if (sponsor) {
      redirectToSponsor();
    }
  }, [appTrigger]);

  // Pre-reg fields

  const gaEventTracker = useAnalyticsEventTracker('Home');

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setCurrentPage(PageType.HOME));
  }, []);

  const [scrollPosition, setScrollPosition] = useState(0);

  const handleScroll = () => {
    const position = window.scrollY;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Helmet>
        <meta
          name="title"
          content="RouteBuddies | The Community Safety App | Safer Together"
        />
        <meta
          name="description"
          content="Street safety, in numbers. RouteBuddies strides to make streets safer through our community driven app, established in 2022 and coming to a city near you soon."
        />
        <meta
          name="keywords"
          content="safety, safety app, routebuddies, route, buddies, app, safeguarding, jack blundell, routebuddies app, cardiff safety app, cardiff app, cardiff routebuddies, cardiff buddies, jack blundell, jack blundell cardiff, routebuddies safety, best safety app"
        />
        <meta name="robots" content="index, follow" />
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta name="author" content="RouteBuddies Limited." />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
      </Helmet>

      <NavBar
        theme={theme}
        navigate={navigate}
        loggedIn={false}
        transparent={true}
      />

      <Grid
        container
        flexDirection={'column'}
        sx={{
          maxWidth: '100vw',
        }}
      >
        {/* Section 1 - Intro*/}
        <Grid
          container
          flexDirection={'row'}
          style={{
            backgroundColor: 'white',
          }}
        >
          <Grid item container sx={{}} xs={12}>
            {/* Text */}
            <FadeInComponent scrollPosition={scrollPosition}>
              <Grid item container md={12} sx={{ padding: '20px' }}>
                <Grid
                  item
                  container
                  md={12}
                  sx={{
                    height: {
                      md: `auto`,
                    },

                    marginBottom: {
                      xs: 5,
                      sm: 5,
                    },

                    backgroundColor: '#fff3f1',
                    borderRadius: '20px',
                  }}
                  style={{
                    minHeight: 'Calc(100vh - 260px)',
                    overflow: 'hidden',
                    position: 'relative',
                  }}
                >
                  <Grid
                    item
                    xs={11}
                    sm={11}
                    md={7}
                    lg={5}
                    sx={{ padding: { xs: 8, sm: 8, md: 8, zIndex: 2 } }}
                    style={{
                      height: 'inherit',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <div
                      style={{
                        justifyContent: 'flex-start',
                        position: 'relative',
                      }}
                    >
                      <Typography
                        variant="h5"
                        style={{
                          color: primaryColor,
                          ...styles.titleSize,
                          fontWeight: '900',
                          backdropFilter: 'blur(3px)',
                        }}
                      >
                        Find Buddies For Every Adventure
                      </Typography>

                      <Typography
                        variant={'body2'}
                        textAlign={'left'}
                        color={'black'}
                        style={{
                          fontFamily: 'Urbanist',
                          borderRadius: 3,
                          paddingTop: '5px',
                          zIndex: 2,
                          paddingBottom: '20px',
                          letterSpacing: 1.4,
                          backdropFilter: 'blur(3px)',

                          ...styles.subheader2Size,
                        }}
                      >
                        Discover the magic of RouteBuddies. The #1 solution to
                        help communities connect & stay safe on-the-go.
                      </Typography>

                      <Grid container justifyContent={'flex-start'}>
                        <Button
                          style={{
                            padding: 20,
                            borderRadius: '100px',
                            backgroundColor: primaryColor,
                            color: 'white',
                            paddingLeft: 40,
                            paddingRight: 40,
                            marginTop: 20,
                          }}
                          onClick={() => {
                            window.location.href =
                              'https://routebuddies.com/?appTrigger=true';
                          }}
                        >
                          <Typography
                            style={{
                              color: 'white',
                              fontFamily: 'Urbanist',
                              fontWeight: '700',
                              textTransform: 'none',
                            }}
                          >
                            Try it now
                          </Typography>
                        </Button>
                      </Grid>
                    </div>
                  </Grid>
                  <Grid
                    xs={12}
                    sx={{
                      display: { xs: 'none', md: 'flex' },
                    }}
                  >
                    {' '}
                    <img className="bgImage" src="/static/home_app_main.png" />
                  </Grid>
                </Grid>
              </Grid>
            </FadeInComponent>
          </Grid>
        </Grid>

        {/* <VSNIAnnouncement /> */}

        {/* Section 2 - Features*/}

        {/* Inner Container - Less page width */}

        {/* Section 4 -Why does RouteBuddies Exist */}
        <Grid
          container
          item
          xs={12}
          justifyContent={'center'}
          style={{ backgroundColor: primaryColor }}
        >
          <FadeInComponent scrollPosition={scrollPosition}>
            <Grid container item xs={12}>
              <Grid
                container
                item
                xs={12}
                justifyContent={'center'}
                alignItems={'center'}
                style={{ backgroundColor: primaryColor }}
                paddingTop={0}
              >
                <Grid
                  item
                  container
                  xs={12}
                  sx={{
                    display: {
                      xs: 'none',
                      sm: 'none',
                      md: 'flex',
                    },
                    height: '100%',
                  }}
                  md={5}
                  style={{
                    backgroundImage: `url(/static/app_features_red.png)`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'right',
                  }}
                ></Grid>
                <Grid
                  item
                  container
                  xs={10}
                  md={7}
                  sx={{
                    paddingTop: 15,

                    paddingBottom: 15,
                  }}
                  justifyContent={'center'}
                >
                  <Grid
                    container
                    item
                    xs={12}
                    sm={10}
                    sx={{
                      justifyContent: 'flex-start',
                    }}
                  >
                    <Typography
                      component="h1"
                      variant="h3"
                      color="white"
                      style={{
                        fontWeight: '900',
                      }}
                      sx={{
                        fontSize: styles.titleSize,
                        textTransform: 'capitalize',
                      }}
                    >
                      More than a personal safety app.
                    </Typography>
                    <div
                      style={{
                        width: '100%',
                        height: '10px',
                        backgroundColor: 'white',
                        marginTop: 30,
                        marginBottom: 30,
                      }}
                    />
                    <Typography
                      variant={'body2'}
                      color={'#000'}
                      style={{
                        marginBottom: 10,
                        fontFamily: 'Urbanist',
                        fontSize: 19,
                        color: 'white',
                        letterSpacing: 1.3,
                        marginTop: 10,
                      }}
                    >
                      Let’s be real,{' '}
                      <span style={{ fontWeight: 'bold' }}>
                        personal safety should be the baseline.
                      </span>{' '}
                      That’s why we set out to build a safety app that’s
                      <em> built different</em>.
                    </Typography>

                    <Typography
                      variant={'body2'}
                      color={'#000'}
                      style={{
                        marginBottom: 10,
                        fontFamily: 'Urbanist',
                        fontSize: 19,
                        letterSpacing: 1.3,
                        color: 'white',
                        marginTop: 10,
                      }}
                    >
                      We believe in safety in numbers—and our app makes it easy
                      to link up with local buddies for shared runs, walks,
                      hikes, or rides.
                    </Typography>

                    <Typography
                      variant={'body2'}
                      color={'#000'}
                      style={{
                        marginBottom: 10,
                        fontFamily: 'Urbanist',
                        fontSize: 19,
                        letterSpacing: 1.3,
                        color: 'white',
                        marginTop: 10,
                      }}
                    >
                      With group-trip tracking & in-app live chat, solo and
                      group safeguarding tools, and our{' '}
                      <em>state-of-the-art</em> SOS button—you're always ready
                      for your next adventure.
                    </Typography>

                    <Button
                      style={{
                        padding: 20,
                        borderRadius: '100px',
                        backgroundColor: 'white',
                        color: 'white',
                        paddingLeft: 40,
                        paddingRight: 40,
                        marginTop: 20,
                      }}
                      onClick={() => {
                        window.location.href =
                          'https://routebuddies.com/?appTrigger=true';
                      }}
                    >
                      <Typography
                        style={{
                          color: primaryColor,
                          fontFamily: 'Urbanist',
                          fontWeight: '700',
                          textTransform: 'none',
                        }}
                      >
                        Let's go!
                      </Typography>
                    </Button>

                    {/* <Button
                      onClick={() => {
                        window.location.href =
                          'https://routebuddies.com/?appTrigger=true';
                      }}
                    >
                      <Typography
                        style={{ fontFamily: 'Urbanist', fontWeight: '700' }}
                      >
                        Find your community today
                      </Typography>
                    </Button> */}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </FadeInComponent>
        </Grid>
      </Grid>

      {/* Section 3 - How it works */}

      {/* Inner Container - Less page width */}

      {/* Section 4 -Why does RouteBuddies Exist */}

      <Grid
        container
        item
        xs={12}
        justifyContent={'center'}
        sx={{
          paddingTop: 15,
          backgroundColor: 'white',
          paddingBottom: 10,
        }}
      >
        <FadeInComponent scrollPosition={scrollPosition}>
          <Grid item container xs={12} justifyContent={'center'}>
            <Grid
              container
              flexDirection={'column'}
              alignContent={'center'}
              xs={10}
            >
              <Typography
                component="h2"
                variant="h2"
                color={primaryColor}
                sx={{
                  marginBottom: '10px',

                  fontFamily: 'Urbanist',
                  maxWidth: 600,

                  ...styles.titleSize,
                  fontWeight: 900,
                }}
              >
                What does RouteBuddies do?
              </Typography>
              <div
                style={{
                  width: '100%',
                  height: '10px',
                  backgroundColor: primaryColor,
                  marginTop: 30,
                  marginBottom: 30,
                  maxWidth: 600,
                }}
              />
              <Typography
                variant={'body2'}
                color={'white'}
                style={{
                  marginBottom: 10,
                  fontFamily: 'Urbanist',
                  fontSize: 19,
                  letterSpacing: 1.3,
                  marginTop: 10,

                  color: 'rgba(40,40,40,1)',
                  maxWidth: 600,
                }}
              >
                The RouteBuddies iOS & Android app is transforming the way
                communities keep each other safe on-the-go:
              </Typography>
            </Grid>

            <Grid container justifyContent={'center'}>
              <Features />
            </Grid>
          </Grid>
        </FadeInComponent>
      </Grid>

      <Grid container item xs={12} justifyContent={'center'}>
        <FadeInComponent scrollPosition={scrollPosition}>
          <Grid container item xs={12}>
            <Grid
              container
              item
              xs={12}
              justifyContent={'center'}
              alignItems={'center'}
              style={{ backgroundColor: primaryColor }}
            >
              <Grid
                item
                container
                xs={10}
                md={7}
                sx={{
                  padding: { md: 15 },
                  paddingTop: 15,
                  paddingBottom: 15,
                }}
              >
                <Grid
                  container
                  item
                  sx={{
                    justifyContent: 'flex-start',
                  }}
                >
                  <Typography
                    component="h1"
                    variant="h3"
                    color="white"
                    style={{
                      fontWeight: '700',
                      color: 'white',
                    }}
                    sx={{
                      ...styles.titleSize,
                    }}
                  >
                    We keep it <em>super</em> secure.
                  </Typography>
                  <div
                    style={{
                      width: '100%',
                      height: '10px',
                      backgroundColor: 'white',
                      marginTop: 30,
                      marginBottom: 30,
                    }}
                  />
                  <Typography
                    variant={'body2'}
                    color={'#000'}
                    style={{
                      marginBottom: 10,
                      fontFamily: 'Urbanist',
                      fontSize: 19,
                      letterSpacing: 1.3,
                      marginTop: 10,
                      color: 'white',
                    }}
                  >
                    Public RouteBuddies communities use ID verification - This
                    is so we can keep women only, men only, and mixed spaces
                    secure.
                  </Typography>
                  <Grid
                    item
                    container
                    xs={12}
                    style={{ marginTop: 30 }}
                    spacing={2}
                  >
                    <Grid
                      item
                      flexDirection={'column'}
                      alignItems={'center'}
                      alignContent={'center'}
                      style={{ display: 'flex' }}
                    >
                      <div
                        style={{
                          justifyContent: 'center',
                          alignContent: 'center',
                          alignItems: 'center',
                          width: 60,
                          height: 60,
                          borderRadius: '60px',
                          backgroundColor: 'white',
                        }}
                      >
                        <Typography
                          style={{
                            fontFamily: 'Urbanist',
                            fontWeight: '700',
                            textAlign: 'center',
                            color: primaryColor,
                            fontSize: 20,
                            alignSelf: 'center',
                          }}
                        >
                          1
                        </Typography>
                      </div>
                      <div
                        style={{
                          width: 10,
                          height: 80,
                          marginTop: -10,
                          backgroundColor: 'white',
                        }}
                      />
                    </Grid>
                    <Grid item container flex={1} flexDirection={'column'}>
                      <Typography
                        style={{
                          fontFamily: 'Urbanist',
                          fontSize: 24,
                          letterSpacing: 1.3,
                          color: 'white',
                          textAlign: 'left',
                          width: '100%',
                          fontWeight: '700',
                          alignContent: 'center',
                          marginBottom: 5,
                        }}
                      >
                        Quick Verification
                      </Typography>
                      <Typography
                        variant={'body2'}
                        color={'#000'}
                        style={{
                          fontFamily: 'Urbanist',
                          fontSize: 16,
                          letterSpacing: 1.3,
                          color: 'white',
                        }}
                      >
                        Verify your account to join nearby communities, or
                        create a private group.
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item container xs={12} spacing={2}>
                    <Grid
                      item
                      flexDirection={'column'}
                      alignItems={'center'}
                      alignContent={'center'}
                      style={{ display: 'flex' }}
                    >
                      <div
                        style={{
                          justifyContent: 'center',
                          alignContent: 'center',
                          alignItems: 'center',
                          width: 60,
                          height: 60,
                          borderRadius: '60px',
                          backgroundColor: 'white',
                        }}
                      >
                        <Typography
                          style={{
                            fontFamily: 'Urbanist',
                            fontWeight: '700',
                            textAlign: 'center',
                            color: primaryColor,
                            fontSize: 20,
                            alignSelf: 'center',
                            marginTop: -1,
                          }}
                        >
                          2
                        </Typography>
                      </div>
                      <div
                        style={{
                          width: 10,
                          height: 80,
                          marginTop: -10,
                          backgroundColor: 'white',
                        }}
                      />
                    </Grid>
                    <Grid item container flex={1} flexDirection={'column'}>
                      <Typography
                        style={{
                          fontFamily: 'Urbanist',
                          fontSize: 24,
                          letterSpacing: 1.3,
                          color: 'white',
                          textAlign: 'left',
                          width: '100%',
                          fontWeight: '700',
                          alignContent: 'center',
                          marginBottom: 5,
                        }}
                      >
                        Find Buddies
                      </Typography>
                      <Typography
                        variant={'body2'}
                        color={'#000'}
                        style={{
                          fontFamily: 'Urbanist',
                          fontSize: 16,
                          letterSpacing: 1.3,
                          color: 'white',
                        }}
                      >
                        Find nearby active clubs, event/venue spaces, and much
                        more to vibe with!
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item container xs={12} spacing={2}>
                    <Grid
                      item
                      flexDirection={'column'}
                      alignItems={'center'}
                      alignContent={'center'}
                      style={{ display: 'flex' }}
                    >
                      <div
                        style={{
                          justifyContent: 'center',
                          alignContent: 'center',
                          alignItems: 'center',
                          width: 60,
                          height: 60,
                          borderRadius: '60px',
                          backgroundColor: 'white',
                          marginTop: -1,
                        }}
                      >
                        <Typography
                          style={{
                            fontFamily: 'Urbanist',
                            fontWeight: '700',
                            textAlign: 'center',
                            color: primaryColor,
                            fontSize: 20,

                            alignSelf: 'center',
                          }}
                        >
                          3
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item container flex={1} flexDirection={'column'}>
                      <Typography
                        style={{
                          fontFamily: 'Urbanist',
                          fontSize: 24,
                          letterSpacing: 1.3,
                          color: 'white',
                          textAlign: 'left',
                          width: '100%',
                          fontWeight: '700',
                          alignContent: 'center',
                          marginBottom: 5,
                        }}
                      >
                        Buddy Up!
                      </Typography>
                      <Typography
                        variant={'body2'}
                        color={'#000'}
                        style={{
                          fontFamily: 'Urbanist',
                          fontSize: 16,
                          letterSpacing: 1.3,
                          color: 'white',
                        }}
                      >
                        Create your first trip in the app, and have fun on your
                        adventures!
                      </Typography>
                    </Grid>
                  </Grid>

                  <Button
                    style={{
                      padding: 20,
                      borderRadius: '100px',
                      backgroundColor: 'white',
                      color: primaryColor,
                      paddingLeft: 40,
                      paddingRight: 40,
                      marginTop: 40,
                    }}
                    onClick={() => {
                      window.location.href =
                        'https://routebuddies.com/?appTrigger=true';
                    }}
                  >
                    <Typography
                      style={{
                        color: primaryColor,
                        fontFamily: 'Urbanist',
                        fontWeight: '700',
                        textTransform: 'none',
                      }}
                    >
                      Let's get started!
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
              <Grid
                item
                container
                xs={12}
                sx={{
                  display: {
                    xs: 'none',
                    sm: 'none',
                    md: 'flex',
                  },
                  height: '100%',
                }}
                md={5}
                style={{
                  backgroundImage: `url(/static/verification.png)`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'left',
                }}
                justifyContent={'center'}
                alignItems={'center'}
              >
                {/* <img
                  src="/static/verification.png"
                  style={{ width: '260px', height: 'auto' }}
                /> */}
              </Grid>
            </Grid>
          </Grid>
        </FadeInComponent>
      </Grid>
      <Grid
        container
        item
        xs={12}
        justifyContent={'center'}
        sx={{
          paddingTop: 15,
          backgroundColor: 'white',
          paddingBottom: 10,
        }}
      >
        <FadeInComponent scrollPosition={scrollPosition}>
          <Grid item container xs={12} justifyContent={'center'}>
            <Grid
              container
              flexDirection={'column'}
              alignContent={'center'}
              xs={10}
            >
              <Typography
                component="h2"
                variant="h2"
                color={primaryColor}
                sx={{
                  marginBottom: '10px',

                  fontFamily: 'Urbanist',
                  maxWidth: 600,

                  ...styles.titleSize,
                  fontWeight: 900,
                }}
              >
                Who does RouteBuddies help?
              </Typography>
              <div
                style={{
                  width: '100%',
                  height: '10px',
                  backgroundColor: primaryColor,
                  marginTop: 30,
                  marginBottom: 30,
                  maxWidth: 600,
                }}
              />
              <Typography
                variant={'body2'}
                color={'white'}
                style={{
                  marginBottom: 10,
                  fontFamily: 'Urbanist',
                  fontSize: 19,
                  letterSpacing: 1.3,
                  marginTop: 10,

                  color: 'rgba(40,40,40,1)',
                  maxWidth: 600,
                }}
              >
                We support communities of all kinds, but we're absolutely loved
                by:
              </Typography>
            </Grid>

            <Grid container justifyContent={'center'}>
              <OurClients />
            </Grid>
          </Grid>
        </FadeInComponent>
      </Grid>
    </>
  );
}
